import { lazy } from "react";

export const ApprovalsView = lazy(() => import("./ApprovalsView"));
